{
  "page": {
    "title": "Mẫu thiết kế",
    "subtitle": "Quản lý các mẫu sản phẩm dùng chung và quy tắc kiểm tra của chúng. Mọi quản trị viên đều thấy tất cả mẫu.",
    "regionErrors": "Lỗi vùng",
    "newTemplate": "+ Tạo mẫu"
  },
  "filters": {
    "search": "Tìm kiếm",
    "searchPlaceholder": "Tìm theo mã, tên, biệt danh…",
    "status": "Trạng thái",
    "statusAll": "Tất cả",
    "statusActive": "Đang bật",
    "statusInactive": "Đang tắt",
    "type": "Loại",
    "typeAll": "Tất cả loại",
    "typePrint": "In",
    "typeEmbroidery": "Thêu",
    "productKind": "Loại sản phẩm",
    "productKindAll": "Tất cả loại sản phẩm",
    "productKindApparel": "Thời trang",
    "productKindHomeDecor": "Trang trí nhà",
    "material": "Chất liệu",
    "materialAll": "Tất cả chất liệu",
    "materialFabric": "Vải",
    "materialWood": "Gỗ",
    "materialMirrorAcrylic": "Acrylic gương",
    "materialFrostedAcrylic": "Acrylic mờ",
    "materialClearAcrylic": "Acrylic trong",
    "showDeleted": "Hiện đã xoá"
  },
  "table": {
    "selectAll": "Chọn tất cả hàng trên trang này",
    "selectRow": "Chọn mẫu {{code}}",
    "code": "Mã",
    "name": "Tên",
    "productKind": "Loại sản phẩm",
    "partCount": "Bộ phận",
    "layerCount": "Lớp",
    "regionCount": "Vùng",
    "status": "Trạng thái",
    "updated": "Cập nhật",
    "actions": "Thao tác"
  },
  "status": {
    "active": "Đang bật",
    "inactive": "Đang tắt",
    "deleted": "Đã xoá"
  },
  "rowActions": {
    "restore": "Khôi phục",
    "toggleActiveLabel": "Bật/tắt cho {{code}}",
    "on": "Bật",
    "off": "Tắt"
  },
  "bulk": {
    "selectedCount": "Đã chọn {{n}}",
    "activate": "Bật",
    "deactivate": "Tắt",
    "export": "Xuất"
  },
  "empty": "Không có mẫu nào khớp bộ lọc hiện tại.",
  "toasts": {
    "activated": "Đã bật mẫu",
    "deactivated": "Đã tắt mẫu",
    "activatedDesc": "Đã bật {{modified}} mẫu",
    "activatedPartialDesc": "Đã bật {{modified}} ({{already}} đã bật sẵn)",
    "deactivatedDesc": "Đã tắt {{modified}} mẫu",
    "deactivatedPartialDesc": "Đã tắt {{modified}} ({{already}} đã tắt sẵn)",
    "bulkActivateFailed": "Bật hàng loạt thất bại",
    "bulkDeactivateFailed": "Tắt hàng loạt thất bại",
    "exportReady": "Sẵn sàng xuất",
    "exportReadyDesc": "Đã xuất {{count}} trong {{requested}} mẫu đã chọn",
    "exportReadyAllDesc": "Đã xuất tất cả {{count}} mẫu",
    "exportFailed": "Xuất thất bại",
    "templateActivated": "Đã bật mẫu",
    "templateDeactivated": "Đã tắt mẫu",
    "activateFailed": "Bật thất bại",
    "deactivateFailed": "Tắt thất bại",
    "restored": "Đã khôi phục mẫu",
    "restoreFailed": "Khôi phục thất bại"
  },
  "confirmToggle": {
    "activateTitle": "Kích hoạt mẫu?",
    "deactivateTitle": "Tắt mẫu?",
    "activateDesc": "Bật lại mẫu \"{{name}}\" ({{code}}). Mẫu sẽ hiển thị trên mọi nơi đang dùng nó.",
    "deactivateDesc": "Tắt mẫu \"{{name}}\" ({{code}}). Những nơi đang dùng mẫu này sẽ tạm ẩn cho tới khi bật lại.",
    "activateConfirm": "Bật",
    "deactivateConfirm": "Tắt",
    "cancel": "Huỷ",
    "deactivateDescInUse": "Tắt mẫu \"{{name}}\" ({{code}})? Mẫu đang được {{blueprints}} blueprint và {{skus}} SKU sử dụng — {{names}}{{more}}. Các SKU đó sẽ mất mẫu này, và blueprint không còn vùng in nào thì không mở bán được."
  },
  "createDialog": {
    "title": "Template mới",
    "subtitle": "Tạo template tối thiểu (code + tên EN + loại). Bổ sung regions / validation rules sau ở trang chi tiết.",
    "codeLabel": "Code *",
    "codeHint": "Chỉ a-z, A-Z, 0-9, dấu gạch dưới hoặc gạch nối (1-50 ký tự).",
    "nameLabel": "Tên (EN) *",
    "typeLabel": "Loại *",
    "cancel": "Huỷ",
    "submit": "Tạo",
    "submitting": "Đang tạo…",
    "successTitle": "Đã tạo template",
    "errorTitle": "Tạo template thất bại"
  },
  "inUse": {
    "title": "Template này đang được sử dụng",
    "description": "Đang được {{blueprints}} blueprint và {{skus}} SKU tham chiếu. Tắt nó sẽ khiến template biến mất khỏi danh sách chọn của SKU.",
    "blueprintLevel": "Áp dụng cho toàn bộ blueprint",
    "skuList": "SKU: {{skus}}",
    "consequence": "Vùng in được sinh ra từ template của SKU, và blueprint không có vùng in thì không mở bán được. Đơn hàng đã tạo không bị ảnh hưởng.",
    "cancel": "Giữ đang bật",
    "confirm": "Vẫn tắt",
    "working": "Đang tắt…"
  },
  "notReady": {
    "perTemplate": "{{code}}: {{reasons}}",
    "andMore": "…và {{n}} template khác",
    "TEMPLATE_ACTIVE_NO_PART": "chưa có vùng in — hãy thêm ít nhất một vùng, hoặc một bộ phận có lớp artwork",
    "TEMPLATE_ACTIVE_PART_NO_LAYER": "có bộ phận chưa có lớp nào — hãy thêm ít nhất một lớp",
    "TEMPLATE_ACTIVE_NO_ARTWORK_LAYER": "chưa có lớp artwork nên không in được gì lên",
    "TEMPLATE_LAYER_ARTWORK_NO_REGION": "lớp artwork chưa có vùng in nào có kích thước",
    "TEMPLATE_LAYER_ARTWORK_NO_FILE": "lớp artwork chưa có tệp nào"
  }
}
